//if an anchor link href matches an element ID on the page then add an active class to anchor link 

function observeCurrentSectionIDandUpdateTableOfContents() { 

    const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const sideColumnAnchorLink = document.querySelector(`a[href="#${id}"].side-column-anchor-link`);

        if (entry.intersectionRatio > 0) {
            sideColumnAnchorLink?.classList.add('active');
            // sideColumnAnchorLink?.classList.add('last-active');

        } else {
            sideColumnAnchorLink?.classList.remove('active');
        }
        
        // //when the page scrolls past the last anchor link that was active then add a class of last-active to the last anchor link. When a new active class is created, remove this class from the previously active anchor link.
        // const allAnchorLinks = document.querySelectorAll('.side-column-anchor-link');
        // const activeAnchorLinks = document.querySelectorAll('.side-column-anchor-link.active');
        // const lastActiveAnchorLink = document.querySelector('.side-column-anchor-link.last-active');

        // if (activeAnchorLinks.length > 0) {
        //     const lastActive = activeAnchorLinks[activeAnchorLinks.length - 1];
        //     if (lastActive !== lastActiveAnchorLink) {
        //         lastActive?.classList.add('last-active');
        //         lastActiveAnchorLink?.classList.remove('last-active');
        //     }
        // } else {
        //     lastActiveAnchorLink?.classList.remove('last-active');
        // }   

        
    });
    });
    

    // Track all sections that have an `id` applied
    document.querySelectorAll('.wp-block-group[id], .wp-block-group *[id]').forEach((section) => {
        console.log('observing section with ID:', section.getAttribute('id'));
        observer.observe(section);
    });
}

document.addEventListener('DOMContentLoaded', function () {

    observeCurrentSectionIDandUpdateTableOfContents();
});

//convert the below function to the above

